import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { baseUrl } from './url';

@Injectable({
  providedIn: "root"
})
export class CommonService {
  httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" })
  };
  // baseUrl = "https://ros.com.sg/demo/rosapi/";

  constructor(private http: HttpClient) {}

  getHomeImages(): Observable<any> {
    return this.http.get<any>(baseUrl + "menu.php/home_page");
  }


   getMediaimages(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/media");
  }

  getPackages(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/packages");
  }
  getFabrication(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/fabrication");
  }
  getEpcic() {
    return this.http.get<any>(baseUrl + "ros.php/epcic");
  }
  getFooter(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/footer");
  }
  contact(message): Observable<any> {
    return this.http.post(baseUrl + "ros.php/contact_us", message);
  }

  getCareerList(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/career_list");
  }
  getCareerSubtitle(): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/career_sub_title");
  }
  getCareerTitle(id): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/career_titles/"+id);
  }
  getImages(tble): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/"+tble);
  }
  getCommon(tble): Observable<any> {
    return this.http.get<any>(baseUrl + "ros.php/" + tble);

  }
}
